import { CountryCode, FSD_EXTERNAL_LINK, OFFER_STORE_EXTERNAL_LINK } from '~shared/constants';
import { OtherBuckets } from '~shared/modules/catalog/constants/other-buckets.constants';

export const getOtherBucketsUrl = (country: CountryCode) => {
  return {
    [OtherBuckets.OfferAndStore]: `${OFFER_STORE_EXTERNAL_LINK[country]}/search?q=`,
    [OtherBuckets.DeliveryService]: `${FSD_EXTERNAL_LINK[country]}?q=`,
  }
}
